module.exports = __webpack_public_path__ + "img/CodeWithMe_icon.36042587.png";